import { Card, CardContent, Typography } from '@mui/material';
import ContextTemplatesManager from '@/components/team/ContextTemplatesManager';

interface ContextTemplatesSubTabProps {
  teamId: string;
  onNotify: (message: string, severity: 'success' | 'error') => void;
}

export default function ContextTemplatesSubTab({ teamId, onNotify }: ContextTemplatesSubTabProps) {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          AI Context Templates
        </Typography>
        <ContextTemplatesManager teamId={teamId} onNotify={onNotify} />
      </CardContent>
    </Card>
  );
}
